import SubHeader from '@/components/Common/SubHeader/SubHeader';
import SunnyLink from '@/components/Common/SunnyLink';
import Swiper from '@/components/Common/Swiper/Swiper';
import { IRaffleDealV3Image } from '@/models/RaffleDeal/interfaces/IRaffleDealPromotionsPayload';
import { GlobalStoreCtx } from '@/stores/GlobalStore';
import { ReactIdSwiperProps } from '@yanolja-org/react-swiper';
import { getYaNative } from '@yanolja-org/ya-native';
import React, { useContext, useMemo } from 'react';

import styles from './RaffleDealBanner.module.scss';

interface IRaffleDealBannerProps {
  banners: IRaffleDealV3Image[];
}

const RaffleDealBanner: React.FC<IRaffleDealBannerProps> = ({ banners }) => {
  const globalStore = useContext(GlobalStoreCtx);
  const swiperConfig = useMemo<ReactIdSwiperProps>(
    () => ({
      slidesPerView: 'auto',
      spaceBetween: 8,
      slidesOffsetBefore: globalStore.IsPc ? 40 : 20,
      slidesOffsetAfter: globalStore.IsPc ? 40 : 20,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    }),
    [],
  );

  const goToBanner = (link: string): void => {
    const yaNative = getYaNative();
    if (yaNative.isEnabled) {
      window.location.href = `yanoljamotel://wv?url=${link}`;
    } else {
      window.location.href = link;
    }
  };

  return (
    <div className={styles.container}>
      <SubHeader className={styles.subHeader}>혜택 더 보기</SubHeader>

      <Swiper className={styles.swiper} itemType="banner" {...swiperConfig}>
        {banners.map((banner, idx) => (
          <SunnyLink key={idx} className={styles.banner} onClick={() => banner.link && goToBanner(banner.link)}>
            <img src={banner.url} alt={banner.altText || '혜택 배너'} />
          </SunnyLink>
        ))}
      </Swiper>
    </div>
  );
};

export default RaffleDealBanner;
